// extracted by mini-css-extract-plugin
export default {"container":"Hero_container__ZefRC","contentContainer":"Hero_contentContainer__tyLor","wrapper":"Hero_wrapper__70nxj","teamImg":"Hero_teamImg__TVqK0"};